import type { VellumAuthMeResponse } from "@vellum/vellum-api";

/**
 * Only full admins get into this app — region admins are deliberately excluded,
 * matching the `verify_admin` dependency guarding every `/api/v1/admin` route.
 */
export function isAdmin(user: VellumAuthMeResponse | null): boolean {
  return user?.role === "Admin";
}
